import React from 'react'
import { vision } from '../../../assets/img'
import { Col } from 'react-bootstrap'

const FutureLeft = () => {
    return (
        <Col xs={12} md={5} className="tl-service align-items-center justify-content-center">
            <div className="service-box ac-jc d-flex flex-wrap w-100">
                <div className="bg-white">
                    <div className="box-inner1">
                        <img
                            src={vision}
                            className="image-abt object-fit-contain px-5"
                            loading='lazy'
                        />
                    </div>
                </div>
            </div>
        </Col>
    )
}

export default FutureLeft